<template>
  <div class="simplifica-publicity-container">
    <div class="wrapper" :style="`justify-content: ${ isMobile ? 'flex-start' : 'flex-end'};`">
      <PbAccordion
        :title="hasCookie ? 'Para minha empresa' : `Olá, ${userName}`"
        class="accordion-component"
        :open="!hasCookie"
        @click.native="saveCookie"
      >
        <div style="background-color: #FFFFFF; padding: 10px;">
          <p class="pb-md">Sua empresa <strong>{{ entity }}</strong> também pode atender os seus clientes através dessa plataforma.</p>
    
          <div class="buttons">
            <a href="https://simplificamais.com.br" target="_blank">
              <img width="80px" src="static/simplifica-mais-logo.svg">
            </a>
      
            <PbButton
              label="Saiba Mais"
              color="primary"
              button-style="background"
              button-size="medium"
              @click.native="goToLink"
            />
          </div>
        </div>
      </PbAccordion>
    </div>
  </div>
</template>

<script>
import { PbAccordion, PbButton } from 'vue-polar-bear';

export default {
  name: 'SimplificaPublicity',
  
  components: {
    PbAccordion,
    PbButton,
  },
  
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  
  computed: {
    userName() {
      return brain.user.getFirstNick();
    },

    entity() {
      let description = brain.user?.selectedEntity[0]?.description || '';

      if (description.includes('-')) {
        description = description.split('-');
        description.shift();
        description = description.join(' ');
      }

      return description.toLowerCase().split(' ').map(str => str.charAt(0).toUpperCase() + str.slice(1)).join(' ');
    },

    isMobile() {
      return this.windowWidth <= 785;
    },

    hasCookie() {
      return localStorage['pop-up'];
    },
  },

  mounted() {
    window.addEventListener('resize', this.setWindowWidth);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setWindowWidth);
  },

  methods: {
    setWindowWidth({ target } = {}) {
      if (!target) return;

      this.windowWidth = target.innerWidth;
    },

    goToLink() {
      window.open(brain.company.json.simplificaPublicityLink, '_blank');
      brain.setActivity('simplificaPublicityClick', { simplificaPublicityLink: brain.company.json.simplificaPublicityLink }, false);
    },

    saveCookie() {
      localStorage['pop-up'] = true;
    },
  },
};
</script>

<style lang="scss">
.simplifica-publicity-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  pointer-events: none !important;
}

.wrapper {
  display: flex;
  margin-right: 1vh;

  .accordion-component {
    width: 220px !important;
    pointer-events: visible !important;
    
    .accordion {
      background-color: var(--color-primary) !important;

      h6 {
        color: var(--color-white) !important;
      }

      .pb-collapse-icon > span {
        background: var(--color-white) !important;
      }
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
